import { render } from "./ItemNotAllowedDialog.vue?vue&type=template&id=44bb009f&scoped=true"
import script from "./ItemNotAllowedDialog.vue?vue&type=script&lang=js"
export * from "./ItemNotAllowedDialog.vue?vue&type=script&lang=js"

import "./ItemNotAllowedDialog.vue?vue&type=style&index=0&id=44bb009f&lang=css"
import "./ItemNotAllowedDialog.vue?vue&type=style&index=1&id=44bb009f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bb009f"]])

export default __exports__